const VALID_CATALOG_SCOPES = ["all", "products", "services"];
const VALID_MERGE_STRATEGIES = ["prefer_conversation", "prefer_ecom", "ask_client"];

export const PRODUCT_SELLER_DEFAULT_MESSAGES = {
  intro_message:
    "Olá! Sou seu consultor de vendas. Posso ajudar a encontrar produtos e serviços, montar seu pedido e concluir a compra por aqui.",
  resume_cart_message:
    "Vi que você já tinha itens no carrinho. Quer continuar de onde parou ou ajustar algo?",
};

export function normalizeProductSellerConfig(config = {}) {
  const scopeRaw = String(config.catalog_scope || config.catalogScope || "all").trim().toLowerCase();
  const mergeRaw = String(config.merge_strategy || config.mergeStrategy || "prefer_conversation")
    .trim()
    .toLowerCase();

  return {
    intro_message: config.intro_message ?? PRODUCT_SELLER_DEFAULT_MESSAGES.intro_message,
    sales_tone: config.sales_tone ?? "",
    sales_answer_focus: config.sales_answer_focus ?? "",
    custom_instructions: config.custom_instructions ?? "",
    category_focus_ids: config.category_focus_ids ?? [],
    catalog_scope: VALID_CATALOG_SCOPES.includes(scopeRaw) ? scopeRaw : "all",
    use_purchase_history: config.use_purchase_history !== false,
    cross_sell_enabled: config.cross_sell_enabled !== false,
    default_payment_method_id:
      config.default_payment_method_id ?? config.id_formadepagamento ?? "",
    allowed_payment_method_ids: config.allowed_payment_method_ids ?? [],
    require_email_for_payment: config.require_email_for_payment !== false,
    outside_hours_message: config.outside_hours_message ?? "",
    business_hours: config.business_hours ?? null,
    omnichannel_enabled: config.omnichannel_enabled !== false,
    merge_cart_max_age_hours: config.merge_cart_max_age_hours ?? 48,
    merge_strategy: VALID_MERGE_STRATEGIES.includes(mergeRaw) ? mergeRaw : "prefer_conversation",
    ecom_resume_base_url: config.ecom_resume_base_url ?? "",
    resume_cart_message: config.resume_cart_message ?? PRODUCT_SELLER_DEFAULT_MESSAGES.resume_cart_message,
  };
}

export const CATALOG_SCOPE_OPTIONS = [
  { value: "all", labelKey: "agentsListPage.productSellerCatalogAll" },
  { value: "products", labelKey: "agentsListPage.productSellerCatalogProducts" },
  { value: "services", labelKey: "agentsListPage.productSellerCatalogServices" },
];

export const MERGE_STRATEGY_OPTIONS = [
  { value: "prefer_conversation", labelKey: "agentsListPage.productSellerMergePreferConversation" },
  { value: "prefer_ecom", labelKey: "agentsListPage.productSellerMergePreferEcom" },
  { value: "ask_client", labelKey: "agentsListPage.productSellerMergeAskClient" },
];
